import {
  Link,
  Text,
} from '@chakra-ui/react';
import {
  useCyclewaysNetworkLength,
} from '@src/modules/performance/context/reports-api-hooks';
import StackedAreaChart from '@src/modules/performance/components/charts/StackedAreaChart';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Cycleways',
  content: [
    {
      title: 'Network length (km)',
      description:
  <Text fontSize="inherit" mb={2}>
    The length of the cycleway network reported by an urban and rural split.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, physical statistics - cycleways</Link>
  </Text>,
    },
  ],
};

function NetworkPhysicalCharacteristicsCycleways() {
  const { data: cyclewaysNetworkLength, isLoading } = useCyclewaysNetworkLength();

  // Chart Data
  const years = [...new Set(cyclewaysNetworkLength?.map((item) => item.Year))];
  const chartData = [
    {
      name: 'Rural',
      type: 'area',
      data: cyclewaysNetworkLength
        ?.filter((x) => x.Type === 'R' || x.Type === 'Rural')
        .map((item) => ({
          x: item.Year,
          y: item.Length,
        })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'Urban',
      type: 'area',
      data: cyclewaysNetworkLength?.filter((x) => x.Type === 'U' || x.Type === 'Urban')
        .map((item) => ({
          x: item.Year,
          y: item.Length,
        })),
      color: CHART_COLOURS.grey,
    },
  ];

  return (
    <ReportSection
      title="Cycleways"
      isLoading={isLoading || !cyclewaysNetworkLength}
      informationSource={informationSource}
      lockYear={cyclewaysNetworkLength?.[0]?.LockYear || null}
    >
      <StackedAreaChart
        title="Network length (km)"
        categories={years}
        series={chartData}
        width="100%"
        height="280"
        prefix=""
        suffix="km"
        decimalPoints={1}
        yAxisDecimalPoints={1}
      />
    </ReportSection>
  );
}

export default NetworkPhysicalCharacteristicsCycleways;
